
import React from 'react';

const convertPropsToObject = item => {
  const props = item.properties.reduce((merged, current) => {
    if (current?.valueType === 'SCALAR') {
      merged[current.name] = {
        type: current.type,
        value: current?.value?.value,
        __typename: current?.value?.__typename
      };
    } else {
      merged[current.name] = {
        type: current.type,
        value: current.value
      };
    }
    return merged;
  }, {});

  return props;
};
const renderContent = ({ items, components, extraData }) => {
  return items?.map((item, index) => {
    const Component =
      components[item.type.toUpperCase()] || components[item.type];

    const props = convertPropsToObject(item);
    props.itemIndex = index;
    props.itemQty = items.length;
    if (extraData) {
      props.extraData = extraData;
    }
    if (Component) {
      return (
        <Component key={`${item.type}-${index}`} {...props}>
          {item?.children && item.children.length > 0
            ? renderContent({ items: item.children, components })
            : null}
        </Component>
      );
    } else return null;
  });
}

export function ContentRenderer({ items, components, extraData }) {
  return (
    <>
      {renderContent({ items, components, extraData })}
    </>
  );
}
